import React from 'react'

import { ScrollableTabView, TabView } from 'widgets/TabView'

type TabViewWithFiltersProps = {
  children: React.ReactNode | React.ReactNode[]
  header?: React.ReactNode
  hideActionsTabs?: string[]
  tabs: string[]
  onTabChange?: (index: number) => void
  scrollable?: boolean
  withIconTabHeaders?: boolean
}

export const TabViewWithFilters = ({
  tabs = [],
  header,
  hideActionsTabs,
  children,
  onTabChange,
  scrollable = false,
  withIconTabHeaders = false,
}: TabViewWithFiltersProps) => {
  const handleOnTabChange = (index: number) => {
    onTabChange && onTabChange(index)
  }

  const TabViewComponent = scrollable ? ScrollableTabView : TabView

  return (
    <>
      <TabViewComponent
        testID='TabViewWithFilters'
        tabs={tabs}
        withIconTabHeaders={withIconTabHeaders}
        onTabChange={handleOnTabChange}
        hideActionsTabs={hideActionsTabs}
        header={header}
      >
        {children}
      </TabViewComponent>
    </>
  )
}
